<button mat-icon-button (click)="btnClickedHandler()">
	<mat-icon>visibility</mat-icon>
</button>
